export default __webpack_public_path__ + "static/media/live-icon.f7a0e068.webp";